const state = {
  collapse: true,
  fixed: true,
  selectKey: '',
  user: '先生/女士',
  list: [
    {
      key: '0',
      title: '首页',
      icon: 'iconfont icon-shouye_white',
      to: '/home',
    },
    {
      key: '1',
      title: '组织管理',
      icon: 'iconfont icon-xitongshezhi',
      children: [
        {
          key: '1-0',
          title: '部门管理',
          to: '/department',
        },
        {
          key: '1-1',
          title: '职级管理',
          to: '/rank',
        },
        {
          key: '1-2',
          title: '岗位管理',
          to: '/guard',
        },
        {
          key: '1-3',
          title: '职位管理',
          to: '/job',
        },
      ],
    },
    {
      key: '2',
      title: '人事管理',
      icon: 'iconfont icon-xitongshezhi',
      children: [
        {
          key: '2-0',
          title: '入职管理',
          to: '/entry',
        },
        {
          key: '2-1',
          title: '员工管理',
          to: '/staff',
        },
        {
          key: '2-2',
          title: '调转管理',
          to: '/turn',
        },
        {
          key: '2-3',
          title: '离职管理',
          to: '/dimission',
        },
      ],
    },
    {
      key: '3',
      title: '考勤管理',
      icon: 'iconfont icon-xitongshezhi',
      children: [
        {
          key: '3-0',
          title: '考勤设置',
          to: '/attendanceSet',
        },
        {
          key: '3-1',
          title: '考勤记录',
          to: '/attendanceRecord',
        },
        {
          key: '3-2',
          title: '考勤日报',
          to: '/attendanceDaily',
        },
        {
          key: '3-3',
          title: '考勤月报',
          to: '/attendanceMonthly',
        },
      ],
    },
    {
      key: '4',
      title: '权限管理',
      icon: 'iconfont icon-xitongshezhi',
      children: [
        {
          key: '4-0',
          title: '菜单管理',
          to: '/menus',
        },
        {
          key: '4-1',
          title: '角色管理',
          to: '/role',
        },
        {
          key: '4-2',
          title: '用户管理',
          to: '/user',
        },
      ],
    },
  ],
};
const getters = {
  title(state) {
    const key = state.selectKey;
    if (!key) {
      return '';
    }
    let t = '';
    if (key.includes('-')) {
      const arr = key.split('-');
      let i = Number.parseInt(arr[0], 10);
      const j = Number.parseInt(arr[1], 10);
      if (state.list[0].key === '1') {
        i -= 1;
      }
      t = state.list[i].children[j].title;
    } else {
      const i = Number.parseInt(key, 10);
      if (state.list[0].key === '1') {
        t = '';
      } else {
        t = state.list[i].title;
      }
    }
    return t;
  },
};
const mutations = {
  toggleCollapse(state) {
    state.collapse = !state.collapse;
  },
  updateSelectKey(state, payload) {
    state.selectKey = payload;
  },
  toggleFixed(state) {
    state.fixed = !state.fixed;
  },
  navFixed(state) {
    state.collapse = false;
  },
  navFixedin(state) {
    state.collapse = true;
    state.selectKey = '0';
  },
  SET_MENU(state, list) {
    state.list = list;
  },
};
const actions = {
  updateMenu({ commit }, routers) {
    return new Promise(resolve => {
      const menu = [];
      // 根据routers生成menus
      routers.forEach((element, index) => {
        const fatherPath = element.path;
        const childMenus = [];
        let toPath = '';
        if (element.meta.code === '1401') {
          toPath = '/homepage/home';
        } else {
          element.children.forEach((child, chindIndex) => {
            childMenus.push({
              key: `${index}-${chindIndex}`,
              title: child.meta.title,
              to: `${fatherPath}/${child.path}`,
            });
          });
        }
        menu.push({
          key: `${index}`,
          title: element.meta.title,
          icon: element.meta.iconUrl,
          to: toPath || '',
          children: childMenus || [],
        });
      });
      commit('SET_MENU', menu);
      resolve(menu);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
